import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import BusinessInvoicesBlockData from 'app/Models/Content/BusinessInvoicesBlockData';
import React, {useContext, useEffect} from 'react';
import BusinessInvoicesSearch from './BusinessInvoicesSearch';
import BusinessInvoicesContext from 'app/Components/Page/BusinessInvoicesPage/BusinessInvoicesContext';
import BusinessInvoicesResults from './BusinessInvoicesResults';
import BusinessInvoicesResultsSend from './BusinessInvoicesResultsSend';
import BusinessInvoicesSort from './BusinessInvoicesSort';
import BusinessInvoicesPdf from './BusinessInvoicesPdf';
import BusinessInvoicesEmail from './BusinessInvoicesEmail';
import BusinessInvoicesTimeout from './BusinessInvoicesTimeout';
import BusinessInvoicesSelect from './BusinessInvoicesSelect';
import InnerLoader from 'app/Components/Shared/Loader/InnerLoader';
import ProviderManager from 'app/provider/providerManager';
import {Container} from 'reactstrap';
import {connect} from 'react-redux';

import BusinessInvoicesSearchCollapsed from './BusinessInvoicesSearchCollapsed';

const mapStateToProps = (state) => {
  return {
    selectedFromPortal: state.portalsBlock.selectedHetPay as string,
  };
};

type StateProps = ReturnType<typeof mapStateToProps>;

const BusinessInvoicesBlock = ({selectedFromPortal, data}: ComponentProps<BusinessInvoicesBlockData> & StateProps) => {
  const [{loader, invoices, selected, search, orderBy, pdf}, dispatch] = useContext(BusinessInvoicesContext);

  // initialize company list
  useEffect(() => {
    ProviderManager.getProviderData('getContactCompanyList', []).then((res) =>
      dispatch({type: 'init', list: res.Body, selectedFromPortal}),
    );
  }, [selectedFromPortal]);

  // Listen for history back and forward events
  useEffect(() => {
    const hashHandler = () => {
      const invoiceNumber = location.hash.slice(1);
      if (invoiceNumber) {
        const invoice = invoices?.find((d) => d.invoiceNumber === invoiceNumber);
        if (invoice) dispatch({type: 'open-pdf', invoice});
        else dispatch({type: 'close-pdf'});
      } else {
        dispatch({type: 'close-pdf'});
      }
    };
    if (invoices != null) {
      if (typeof window.scrollTo === 'function') {
        window.scrollTo(0, 0);
      }
    }
    window.addEventListener('hashchange', hashHandler);
    return () => window.removeEventListener('hashchange', hashHandler);
  }, [invoices]);

  // Change History based on pdf iframe
  useEffect(() => {
    if (pdf == null) {
      history.replaceState(null, null, ' ');
    } else {
      location.hash = pdf.invoice.invoiceNumber;
    }
  }, [pdf?.invoice]);

  // Search new parameters
  useEffect(() => {
    if (selected == null || search == null) return;
    let obsolete = false;
    dispatch({type: 'loader'});

    const isFilter = search.filterValue != '';
    const filterByBanPsid = isFilter && search.filterByBanPsid;
    const filterBySubscriber = isFilter && search.filterBySubscriber;

    ProviderManager.getProviderData('getBussinessInvoices', {
      ...search,
      filterByBanPsid,
      filterBySubscriber,
      companyId: selected.idNumber,
      orderBy,
    })
      .then((res) => {
        if (!obsolete) dispatch({type: 'results', data: res.Body.invoices});
      })
      .catch((e) => {
        if (!obsolete) {
          if (e.status === 503) {
            dispatch({type: 'open-timeout'});
          } else {
            dispatch({type: 'results', data: null});
          }
        }
      });
    return () => {
      obsolete = true;
    };
  }, [selected, search, orderBy]);

  return (
    <div className='BusinessInvoicesBlock'>
      <InnerLoader isOverlay={true} isLoading={loader} />
      <Container>
        <BusinessInvoicesSelect />
        <BusinessInvoicesSearchCollapsed />
        <BusinessInvoicesSearch />
        <BusinessInvoicesSort />
        <BusinessInvoicesEmail />
        <BusinessInvoicesTimeout />
      </Container>

      <BusinessInvoicesResults digitalInvoicePage={`${data.digitalInvoicePage?.value}`} />
      <BusinessInvoicesResultsSend />
      <BusinessInvoicesPdf />
    </div>
  );
};

export default connect(mapStateToProps)(BusinessInvoicesBlock);
